module.exports = __webpack_public_path__ + "f1096befec9205b7890fc6d67c3a7132.png";